module.exports = __webpack_public_path__ + "static/media/forPetParents.86a36d23.jpeg";